/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GlobalSearchResultDto } from '../models/global-search-result-dto';

@Injectable({
  providedIn: 'root',
})
export class GlobalService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation find
   */
  static readonly FindPath = '/global';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    search: string;
    limit?: number;
  }): Observable<StrictHttpResponse<Array<GlobalSearchResultDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GlobalService.FindPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<GlobalSearchResultDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    search: string;
    limit?: number;
  }): Observable<Array<GlobalSearchResultDto>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<GlobalSearchResultDto>>) => r.body as Array<GlobalSearchResultDto>)
    );
  }

}
